var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3a13 13 0 1013 13A13.013 13.013 0 0016 3zm-.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM17 23a2 2 0 01-2-2v-5a1 1 0 010-2 2 2 0 012 2v5a1 1 0 010 2z"
  })));
}
export default SvgInfoFill;